/**
 * This module sticks an element to the header
 *
 * @module app/components/StickyHeader
 */
import AnimationFrame from 'animation-frame';
import jQuery from 'jquery';

/**
 * RequestAnimationFrame instance
 *
 * @type    {Object}
 */
var raf = new AnimationFrame();

/**
 * Flag to check if window is scrolling
 *
 * @type {Boolean}
 *
 * @private
 */
var ticking = false;

/**
 * A constant to determine when to trigger animation
 *
 * @type {Integer}
 *
 * @private
 */
var scrollDelta = 2;

/**
 * Keeps last position of y axis
 *
 * @type {Integer}
 *
 * @private
 */
var lastScrollY = 0;

/**
 * The height of the header
 *
 * @type {Integer}
 *
 * @private
 */
var headerHeight = 0;

/**
 * Element to stick
 *
 * @type {Object}
 *
 * @private
 */
var elementToStick;

/**
 * Fires onScroll event for the sticky header
 */
var stickyHeaderScrollStart = function () {

    stickyHeaderScrollOff();
    jQuery(window).on('scroll.stickyheader.scroll', onScroll);
};

/**
 * onScroll event for the sticky header off
 */
var stickyHeaderScrollOff = function () {

    jQuery(window).off('scroll.stickyheader.scroll');
};

/**
 * Fires when window is scrolled.  Uses requestAnimationFrame and a flag to debounce the scroll animation.
 * Performance improvement recommended by http://www.html5rocks.com/en/tutorials/speed/animations/
 *
 * @returns {void}
 *
 * @private
 */
var onScroll = function onScroll() {

    if (!ticking) {

        raf.request(scrollHandler);
    }

    ticking = true;
};

/**
 * The handler which determines if to update the sticky header
 *
 * @returns {void}
 *
 * @private
 */
var scrollHandler = function scrollHandler() {

    var scrollY = window.scrollY;

    if (Math.abs(lastScrollY - scrollY) >= scrollDelta) {
        updateStickyHeaderPosition(scrollY);
    }

    ticking = false;
};

/**
 * Set the correct position when the user scrolls up or down
 *
 * @param   {Integer} currentScrollY       the current position on the y axis
 *
 * @returns {void}
 *
 * @private
 */
var updateStickyHeaderPosition = function update(currentScrollY) {

    if (currentScrollY > headerHeight) {

        elementToStick.css('top', '0');
    } else {

        elementToStick.css('top', headerHeight - currentScrollY);
    }

    lastScrollY = currentScrollY;
};

/**
 * Public functions.
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Initializes Sticky Header component
     *
     * @param {jqElement} element - element that will be sticky
     * @param {Integer} height - height of the header at the top of the page
     *
     * @returns {void}
     *
     * @public
     */
    init: function (element, height) {

        headerHeight = height;
        elementToStick = element;
        stickyHeaderScrollStart();
        updateStickyHeaderPosition(window.scrollY);
    },

    /**
     * Turns off the sticking
     *
     * @returns {void}
     *
     * @public
     */
    off: function () {

        stickyHeaderScrollOff();
    },

};

export default api;
